import {createRouter, createWebHistory} from 'vue-router';
import Login from '@/components/auth/Login.vue';
import PatientsList from '@/components/patients-view/PatientsList.vue';
import PatientDetails from '@/components/patients-view/PatientDetails.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import {auth} from '@/utils/js/firebase';
import {onAuthStateChanged, signOut} from "firebase/auth";


const routes = [
    {
        path: '/auth',
        component: Login,
        meta: {requiresGuest: true}
    },
    {
        path: '/',
        component: PatientsList,
        meta: {requiresAuth: true}
    },
    {
        path: '/patient/:user_id',
        component: PatientDetails,
        meta: {requiresAuth: true},
    },
    {
        path: '/privacy_policy',
        component: PrivacyPolicy,
        meta: {requiresAuth: false, requiresGuest: false},
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});


function getCurrentUser() {
    return new Promise((resolve, reject) => {
        onAuthStateChanged(auth, (user) => {
            resolve(user);
        }, reject);
    });
}

function logout() {
    signOut(auth).then(() => {
        localStorage.removeItem('user-info');
        this.$router.push('/auth');
    }).catch((error) => {
        // An error happened.
        console.log(error);
    });
}


router.beforeEach(async (to, from, next) => {
        let isAuthenticated;

        if (localStorage.getItem("user-info")) {
            const user_info = JSON.parse(localStorage.getItem("user-info"))
            if (user_info.expiry < Date.now()) {
                logout()
            } else {
                isAuthenticated = !!(await getCurrentUser());
            }
        } else {
            isAuthenticated = false;
        }


        // if (sessionStorage.getItem("user-info")) {
        //     isAdmin = JSON.parse(sessionStorage.getItem("user-info")).role === "admin";
        // } else {
        //     isAdmin = false;
        // }

        // const redisClient = createClient({
        //     url: 'redis://localhost:6379'
        // });
        //
        // redisClient.connect()
        //     .then(() => {
        //
        //         const sessionKey = `session:${user.id}`;
        //
        //         redisClient.get(sessionKey, (err, reply) => {
        //             if (err) {
        //                 console.error('Error retrieving session data from Redis:', err);
        //             } else {
        //                 // Convert the JSON string back to an object
        //                 const retrievedSessionData = JSON.parse(reply);
        //                 isAdmin = retrievedSessionData.role === "admin"
        //                 console.log('Retrieved session data:', retrievedSessionData);
        //             }
        //         });
        //     })
        //     .catch((error) => {
        //         console.error('Error connecting to Redis:', error);
        //     })

        if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
            next('/auth');
        } else if (to.matched.some(record => record.meta.requiresGuest) && isAuthenticated) {
            next('/');
        } else {
            next();
        }
    }
)
;

export default router;
